import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import BalanceListContainer from '../../containers/balance/BalanceListContainer';
import { BALANCE_PAGE_NAME } from '../../constants/service/app/balanceConstants';

const BalanceDoneList = () => {
  return (
    <PageTemplate pageName={BALANCE_PAGE_NAME.BALANCE_DONE_LIST}>
      <BalanceListContainer pageType="completed" />
    </PageTemplate>
  );
};

export default BalanceDoneList;
